import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const DeleteDialog = ({ showDialog, title, description, onCancel, onDelete }) => {
    return (
        <Dialog open={showDialog}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {description}
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={onCancel}>Cancel</Button>
                <Button variant='contained' onClick={onDelete}>Delete</Button>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteDialog;
